module.exports = __webpack_public_path__ + "img/background16.33793ad6.jpg";